/** The last few errors in this browser tab, attached to problem reports. Kept in memory only. */
const MAX = 10;
const recent: { at: string; message: string }[] = [];

function remember(message: string) {
  recent.push({ at: new Date().toISOString(), message: message.slice(0, 500) });
  if (recent.length > MAX) recent.shift();
}

export function captureClientErrors() {
  window.addEventListener("error", (e) => remember(e.message || String(e.error)));
  window.addEventListener("unhandledrejection", (e) =>
    remember(e.reason instanceof Error ? `${e.reason.name}: ${e.reason.message}` : String(e.reason)),
  );
}

export const recentClientErrors = () => [...recent];
